import { useState } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { Alert, Button, PageHeader, Select, Spinner } from '../ui/primitives';
import { AuditList } from './RestaurantDetail';

type Log = { id: string; action: string; actorType: string; actorLabel: string | null; data: unknown; ip: string | null; createdAt: string; restaurant: { name: string; slug: string } | null };

const FILTERS = [
  ['', 'Todos os eventos'],
  ['platform.restaurant', 'Restaurantes'],
  ['platform.login', 'Logins DEV'],
  ['staff.login', 'Logins de funcionários'],
  ['platform.subscription', 'Planos'],
];

export function DevAudit() {
  const [action, setAction] = useState('');
  const q = useInfiniteQuery({
    queryKey: ['dev-audit', action],
    initialPageParam: '',
    queryFn: ({ pageParam }) => api<Log[]>(`/api/dev/audit?${new URLSearchParams({ ...(action ? { action } : {}), ...(pageParam ? { before: pageParam } : {}) })}`),
    getNextPageParam: (last) => (last.length === 50 ? last[last.length - 1]!.createdAt : undefined),
  });
  return (
    <>
      <PageHeader
        title="Auditoria"
        description="Ações administrativas e eventos de segurança da plataforma. Registros não podem ser alterados nem apagados."
        action={
          <Select aria-label="Filtrar eventos" className="w-56" value={action} onChange={(e) => setAction(e.target.value)}>
            {FILTERS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </Select>
        }
      />
      {q.isPending && <Spinner />}
      {q.isError && <Alert tone="danger">Não foi possível carregar a auditoria.</Alert>}
      {q.data && <AuditList logs={q.data.pages.flat()} showRestaurant />}
      {q.hasNextPage && (
        <div className="mt-4 flex justify-center">
          <Button variant="secondary" loading={q.isFetchingNextPage} onClick={() => q.fetchNextPage()}>Carregar mais</Button>
        </div>
      )}
    </>
  );
}
